import React from 'react';
import {
    withAuthenticator,
    SignIn,
    SignOut,
    RequireNewPassword,
    Greetings,
    SignUp,
    ForgotPassword,
    Loading,
    ConfirmSignUp,
} from 'aws-amplify-react';
import NewRequestPassword from "./Screens/NewRequestPassword";
import Message from "./Screens/Message";
import MySignIn from "./Screens/MySignIn";
import MySignOut from "./Screens/MySignOut";
import MyLoading from "./Screens/MyLoading";
import MyForgotPassword from "./Screens/MyForgotPassword";
import MySignUp from "./Screens/MySignUp";
import MyConfirmSignUp from "./Screens/MyConfirmSignUp";
import CheckEccAccount from "./Screens/CheckEccAccount";
import ConfirmUpdateEccAccount from "./Screens/ConfirmUpdateEccAccount";

import ChangeEmail from "./Screens/ChengeEmail";
import ConfirmChangeEmail from "./Screens/ConfirmChangeEmail";
import ChangeUserInfo from "./Screens/ChangeUserInfo";

import Wgs from "./Screens/Wgs";
import WgsConsent from "./Screens/WgsConsent";

export const withMyAuthenticator = (Comp, includeGreetings = true) => {
    // signedIn
    let component =  [
        <Message override={Greetings}/>,
        <MySignIn override={SignIn}/>,
        <MyLoading override={Loading}/>,
        <ChangeEmail/>,
        <ConfirmChangeEmail/>,
        <ChangeUserInfo/>,
        <NewRequestPassword override={RequireNewPassword}/>,
        <MyForgotPassword override={ForgotPassword} />,
        <MySignUp override={SignUp}/>,
        <MySignOut override={SignOut}/>,
        <MyConfirmSignUp override={ConfirmSignUp}/>,
        <CheckEccAccount />,
        <ConfirmUpdateEccAccount/>,
        <Wgs/>,
        <WgsConsent/>
    ];
    return withAuthenticator(Comp, includeGreetings, component)
};